import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  isAuthenticated = false;
  menuIsActive = true;
  canHide = false;

  private userSub: Subscription;

  constructor(private router: Router, private http: HttpClient, private authService: AuthService) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (
          val.url == "/create-circuit-1" ||
          val.url == "/create-circuit-2" ||
          val.url == "/create-circuit-3" ||
          val.url == "/create-circuit-4" ||
          val.url == "/create-circuit-5"
        ) {
          this.menuIsActive = false;
          this.canHide = true;
        } else {
          this.menuIsActive = true;
          this.canHide = false;
        }
      }
    });
  }

  ngOnInit(): void {
    this.userSub = this.authService.user.subscribe(user => {
      this.isAuthenticated = !user ? false : true;
    });
  }

  deployMenu() {
    this.menuIsActive = true;
  }

  hideMenu() {
    this.menuIsActive = false;
  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  onLogout() {
    this.authService.logout();
  }

}
